import React from 'react';
import Chart from './Chart';

export default function DualAxisColumnChart(props) {

  const dualAxisColumnOption = {
    chart: {
      type: 'column',
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        marker: {
          enabled: true,
          symbol: 'circle',
          radius: 1
        }
      },
      line: {
        lineWidth: 1,
        marker: {
          enabled: false
        }
      },
      areaspline: {
        lineWidth: 1,
        marker: {
          enabled: false
        },
        shadow: false,
        states: {
          hover: {
            lineWidth: 1
          }
        },
        threshold: null
      },
      area: {
        lineColor: '#ffffff',
        lineWidth: 1,
        marker: {
          enabled: false
        }
      }
    },
    yAxis: [{
      min: 0,
      title: {
        text: ''
      },
      labels: {
        format: '{value}'
      },
      plotLines: [{
        value: 0,
        width: 1,
        color: '#808080'
      }]
    }, {
      title: {
        text: ''
      },
      min: 0,
      max: 100,
      opposite: true,
      labels:{
        formatter: function() {
          return this.value+"%";
        }
      }
    }],
  }

  function serieOption(data) {
    return {
      ...dualAxisColumnOption,
      xAxis: {
        categories: data.categories
      },
      series: [{
        'name': data.series[0]['name'],
        'data': data.series[0]['data'],
        color: '#FF513C',
        type: 'column',
        tooltip: {
          valueDecimals: 1
        }
      },{
        'name': data.series[1]['name'],
        'data': data.series[1]['data'],
        color: '#888888',
        type: 'spline',
        yAxis: 1,
        tooltip: {
          valueDecimals: 1,
          valueSuffix: '%'
        }
      }]
    }
  }

  return (
    <Chart
      options={serieOption(props.data)}
      legendOptions={props.legendOptions}
    />
  )
}
